export type ReviewState = "queued" | "running" | "done" | "failed" | "skipped";

export const STATE_CONFIG: Record<ReviewState, { label: string; dot: string }> = {
  queued: { label: "wartet", dot: "var(--hold-queued)" },
  running: { label: "läuft", dot: "var(--hold-running)" },
  done: { label: "fertig", dot: "var(--hold-done)" },
  failed: { label: "fehlgeschlagen", dot: "var(--hold-failed)" },
  skipped: { label: "übersprungen", dot: "var(--hold-skipped)" },
};

/** Review state as a status dot beside its name; a running review pulses. */
export function StatusBadge({ state }: { state: ReviewState }) {
  const { label, dot } = STATE_CONFIG[state];
  return (
    <span className="inline-flex items-center gap-2 text-sm font-medium">
      <span
        aria-hidden
        className={`dot ${state === "running" ? "dot--live" : ""}`}
        style={{ "--dot": dot } as React.CSSProperties}
      />
      {label}
    </span>
  );
}
